import {lazy} from "react";
import LangSetLangBoot from "./lang/context/SetLangBoot.js";
import LangTransBoot from "./lang/context/TransBoot.js";
import AlertsAlertPanelBoot from "./alerts/context/AlertPanelBoot.js";
import CmsCheckAdminCookieBoot from "./cms/context/CheckAdminCookieBoot.js";
import UsersCheckUserCookieBoot from "./users/context/CheckUserCookieBoot.js";
import CmsCheckAdminRegister from "./cms/context/CheckAdminRegister.js";
import UsersCheckUserRegister from "./users/context/CheckUserRegister.js";
import PagesLoadPagesRegister from "./pages/context/LoadPagesRegister.js";
import PagesMenuRegister from "./pages/context/MenuRegister.js";
import PagesRouteRegister from "./pages/context/RouteRegister.js";
import SettingsLoadSettingsRegister from "./settings/context/LoadSettingsRegister.js";
import SettingsSettingRegister from "./settings/context/SettingRegister.js";
import CategoriesLoadCategoriesRegister from "./categories/context/LoadCategoriesRegister.js";
import DesignCheckPreloadDesignCode from "./design/context/CheckPreloadDesignCode.js";
import WishlistCheckWishlistRegister from "./wishlist/context/CheckWishlistRegister.js";
import OrdersCheckBasketRegister from "./orders/context/CheckBasketRegister.js";
import {authLayoutLoader as cmsAuthLayoutLoader} from "./cms/views/layouts/authLayoutLoader";
import {cmsLayoutLoader as cmsCmsLayoutLoader} from "./cms/views/layouts/cmsLayoutLoader";
import {passwordResetLoader as cmsPasswordResetLoader} from "./cms/views/passwordReset/passwordResetLoader";
import {passwordResetLoader as usersPasswordResetLoader} from "./users/views/auth/passwordReset/passwordResetLoader";
import {authLayoutLoader as usersAuthLayoutLoader} from "./users/views/layouts/authLayoutLoader";
import {userLayoutLoader as usersUserLayoutLoader} from "./users/views/layouts/userLayoutLoader";
import {submitAction as apolloSubmitAction} from "./apollo/providers/submitAction";
import {blocksTemplateLoader as designBlocksTemplateLoader} from "./design/views/blocksTemplate/blocksTemplateLoader";
import {productLoader as productsProductLoader} from "./products/views/product/productLoader";


export const boot=[LangSetLangBoot,LangTransBoot,AlertsAlertPanelBoot,CmsCheckAdminCookieBoot,UsersCheckUserCookieBoot,];
export const register=[CmsCheckAdminRegister,UsersCheckUserRegister,PagesLoadPagesRegister,PagesMenuRegister,PagesRouteRegister,SettingsLoadSettingsRegister,SettingsSettingRegister,CategoriesLoadCategoriesRegister,DesignCheckPreloadDesignCode,WishlistCheckWishlistRegister,OrdersCheckBasketRegister,];

const ReactLazyWithPreload = importStatement => {
  const Component = lazy(importStatement);
  Component.preload = importStatement;
  return Component;
};

export const pages={
  "cms.Administrators": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'cms.Administrators' */ './cms/views/administrators/Administrators.js'))
  },
  "cms.Dashboard": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'cms.Dashboard' */ './cms/views/dashboard/Dashboard.js'))
  },
  "cms.Error404": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'cms.Error404' */ './cms/views/error404/Error404.js'))
  },
  "cms.AuthLayout": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'cms.AuthLayout' */ './cms/views/layouts/AuthLayout.js')),
    "loader": cmsAuthLayoutLoader
  },
  "cms.CmsLayout": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'cms.CmsLayout' */ './cms/views/layouts/CmsLayout.js')),
    "loader": cmsCmsLayoutLoader
  },
  "cms.Login": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'cms.Login' */ './cms/views/login/Login.js')),
    "fallback": "h-80"
  },
  "cms.PasswordEmail": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'cms.PasswordEmail' */ './cms/views/passwordEmail/PasswordEmail.js')),
    "fallback": "h-80"
  },
  "cms.PasswordReset": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'cms.PasswordReset' */ './cms/views/passwordReset/PasswordReset.js')),
    "loader": cmsPasswordResetLoader,
    "fallback": "h-80"
  },
  "users.Login": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'users.Login' */ './users/views/auth/login/Login.js')),
    "fallback": "h-80"
  },
  "users.PasswordEmail": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'users.PasswordEmail' */ './users/views/auth/passwordEmail/PasswordEmail.js')),
    "fallback": "h-80"
  },
  "users.PasswordReset": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'users.PasswordReset' */ './users/views/auth/passwordReset/PasswordReset.js')),
    "loader": usersPasswordResetLoader,
    "fallback": "h-80"
  },
  "users.Register": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'users.Register' */ './users/views/auth/register/Register.js')),
    "fallback": "h-80"
  },
  "users.CmsUsers": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'users.CmsUsers' */ './users/views/cmsUsers/CmsUsers.js'))
  },
  "users.Dashboard": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'users.Dashboard' */ './users/views/dashboard/Dashboard.js'))
  },
  "users.Error404": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'users.Error404' */ './users/views/error404/Error404.js'))
  },
  "users.AuthLayout": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'users.AuthLayout' */ './users/views/layouts/AuthLayout.js')),
    "loader": usersAuthLayoutLoader
  },
  "users.UserLayout": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'users.UserLayout' */ './users/views/layouts/UserLayout.js')),
    "loader": usersUserLayoutLoader
  },
  "users.Profile": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'users.Profile' */ './users/views/profile/Profile.js'))
  },
  "pages.CmsPages": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'pages.CmsPages' */ './pages/views/cmsPages/CmsPages.js'))
  },
  "pages.CmsSeoPages": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'pages.CmsSeoPages' */ './pages/views/cmsSeoPages/CmsSeoPages.js'))
  },
  "settings.CmsSettings": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'settings.CmsSettings' */ './settings/views/cmsSettings/CmsSettings.js'))
  },
  "storage.CmsStorage": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'storage.CmsStorage' */ './storage/views/cmsStorage/CmsStorage.js')),
    "action": apolloSubmitAction
  },
  "public.Error404": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'public.Error404' */ './public/views/Error404/Error404.js'))
  },
  "public.Contact": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'public.Contact' */ './public/views/contact/Contact.js'))
  },
  "public.PublicLayout": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'public.PublicLayout' */ './public/views/layouts/PublicLayout.js'))
  },
  "categories.CmsCategories": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'categories.CmsCategories' */ './categories/views/cmsCategories/CmsCategories.js'))
  },
  "categories.CmsSeoCategories": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'categories.CmsSeoCategories' */ './categories/views/cmsSeoCategories/CmsSeoCategories.js'))
  },
  "filters.CmsFilters": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'filters.CmsFilters' */ './filters/views/cmsFilters/CmsFilters.js'))
  },
  "banners.CmsBanners": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'banners.CmsBanners' */ './banners/views/cmsBanners/CmsBanners.js'))
  },
  "design.BlocksTemplate": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'design.BlocksTemplate' */ './design/views/blocksTemplate/BlocksTemplate.js')),
    "loader": designBlocksTemplateLoader
  },
  "seo.CmsSeoDefault": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'seo.CmsSeoDefault' */ './seo/views/cmsSeoDefault/CmsSeoDefault.js'))
  },
  "seo.CmsSeoSitemap": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'seo.CmsSeoSitemap' */ './seo/views/cmsSeoSitemap/CmsSeoSitemap.js'))
  },
  "products.CmsDiscount": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'products.CmsDiscount' */ './products/views/cmsDiscount/CmsDiscount.js'))
  },
  "products.CmsProducts": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'products.CmsProducts' */ './products/views/cmsProducts/CmsProducts.js'))
  },
  "products.CmsProductsGroups": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'products.CmsProductsGroups' */ './products/views/cmsProductsGroups/CmsProductsGroups.js'))
  },
  "products.CmsSeoProducts": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'products.CmsSeoProducts' */ './products/views/cmsSeoProducts/CmsSeoProducts.js'))
  },
  "products.GroupProducts": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'products.GroupProducts' */ './products/views/groupProducts/GroupProducts.js'))
  },
  "products.Product": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'products.Product' */ './products/views/product/Product.js')),
    "loader": productsProductLoader
  },
  "products.Products": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'products.Products' */ './products/views/products/Products.js'))
  },
  "wishlist.Wishlist": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'wishlist.Wishlist' */ './wishlist/views/wishlist/Wishlist.js'))
  },
  "brands.Products": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'brands.Products' */ './brands/views/Products/Products.js'))
  },
  "brands.Brands": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'brands.Brands' */ './brands/views/brands/Brands.js'))
  },
  "brands.CmsBrands": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'brands.CmsBrands' */ './brands/views/cmsBrands/CmsBrands.js'))
  },
  "brands.CmsSeoBrands": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'brands.CmsSeoBrands' */ './brands/views/cmsSeoBrands/CmsSeoBrands.js'))
  },
  "orders.Checkout": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'orders.Checkout' */ './orders/views/checkout/Checkout.js'))
  },
  "orders.CmsCalendar": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'orders.CmsCalendar' */ './orders/views/cmsCalendar/CmsCalendar.js'))
  },
  "orders.CmsOrders": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'orders.CmsOrders' */ './orders/views/cmsOrders/CmsOrders.js'))
  },
  "orders.CmsOrdersCountries": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'orders.CmsOrdersCountries' */ './orders/views/cmsOrdersCountries/CmsOrdersCountries.js'))
  },
  "orders.CmsOrdersPaymentMethods": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'orders.CmsOrdersPaymentMethods' */ './orders/views/cmsOrdersPaymentMethods/CmsOrdersPaymentMethods.js'))
  },
  "orders.CmsOrdersPromoCodes": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'orders.CmsOrdersPromoCodes' */ './orders/views/cmsOrdersPromoCodes/CmsOrdersPromoCodes.js'))
  },
  "orders.CmsOrdersSettings": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'orders.CmsOrdersSettings' */ './orders/views/cmsOrdersSettings/CmsOrdersSettings.js'))
  },
  "orders.Order": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'orders.Order' */ './orders/views/order/Order.js'))
  },
  "orders.UserOrders": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'orders.UserOrders' */ './orders/views/userOrders/UserOrders.js'))
  }
}

export const widgets={
  "_app.RouterChangedActions": {
    "preload": true,
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: '_app.RouterChangedActions' */ './_app/RouterChangedActions.js'))
  },
  "lang.EditorWrapper": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'lang.EditorWrapper' */ './lang/widgets/EditorWrapper.js'))
  },
  "lang.InputWrapper": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'lang.InputWrapper' */ './lang/widgets/InputWrapper.js'))
  },
  "lang.LangSwitcher": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'lang.LangSwitcher' */ './lang/widgets/LangSwitcher.js'))
  },
  "lang.StorageWrapper": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'lang.StorageWrapper' */ './lang/widgets/StorageWrapper.js'))
  },
  "lang.TextareaWrapper": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'lang.TextareaWrapper' */ './lang/widgets/TextareaWrapper.js'))
  },
  "lang.Wrapper": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'lang.Wrapper' */ './lang/widgets/Wrapper.js'))
  },
  "alerts.Alert": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'alerts.Alert' */ './alerts/widgets/Alert.js'))
  },
  "users.GoogleLoginButton": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'users.GoogleLoginButton' */ './users/views/auth/google/GoogleLoginButton.js'))
  },
  "users.LoginDrawer": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'users.LoginDrawer' */ './users/widgets/LoginDrawer.js'))
  },
  "users.LoginLink": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'users.LoginLink' */ './users/widgets/LoginLink.js'))
  },
  "storage.CmsStorageDrawer": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'storage.CmsStorageDrawer' */ './storage/widgets/CmsStorageDrawer.js'))
  },
  "storage.CmsUpdateStorageDrawer": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'storage.CmsUpdateStorageDrawer' */ './storage/widgets/CmsUpdateStorageDrawer.js'))
  },
  "public.Breadcrumbs": {
    "preload": true,
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'public.Breadcrumbs' */ './public/widgets/Breadcrumbs.js'))
  },
  "public.DarkModeSwitcher": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'public.DarkModeSwitcher' */ './public/widgets/DarkModeSwitcher.js'))
  },
  "public.PopupImage": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'public.PopupImage' */ './public/widgets/PopupImage.js'))
  },
  "categories.CategoryRender": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'categories.CategoryRender' */ './categories/widgets/CategoryRender.js'))
  },
  "categories.CmsAddCategoryProduct": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'categories.CmsAddCategoryProduct' */ './categories/widgets/CmsAddCategoryProduct.js'))
  },
  "categories.CmsCategoriesDrawer": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'categories.CmsCategoriesDrawer' */ './categories/widgets/CmsCategoriesDrawer.js'))
  },
  "categories.CmsCategoriesFilter": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'categories.CmsCategoriesFilter' */ './categories/widgets/CmsCategoriesFilter.js'))
  },
  "categories.CmsDesignBlock": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'categories.CmsDesignBlock' */ './categories/widgets/CmsDesignBlock.js'))
  },
  "categories.DesignBlock": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'categories.DesignBlock' */ './categories/widgets/DesignBlock.js'))
  },
  "categories.MobileCategories": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'categories.MobileCategories' */ './categories/widgets/MobileCategories.js'))
  },
  "categories.ProductsCategoriesMenu": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'categories.ProductsCategoriesMenu' */ './categories/widgets/ProductsCategoriesMenu.js'))
  },
  "filters.CheckoutFilters": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'filters.CheckoutFilters' */ './filters/widgets/CheckoutFilters.js'))
  },
  "filters.CmsAddFilterProduct": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'filters.CmsAddFilterProduct' */ './filters/widgets/CmsAddFilterProduct.js'))
  },
  "filters.CmsFiltersDrawer": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'filters.CmsFiltersDrawer' */ './filters/widgets/CmsFiltersDrawer.js'))
  },
  "filters.OrderFilters": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'filters.OrderFilters' */ './filters/widgets/OrderFilters.js'))
  },
  "filters.ProductsFiltersMenu": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'filters.ProductsFiltersMenu' */ './filters/widgets/ProductsFiltersMenu.js'))
  },
  "filters.ProductsFiltersMenuSelected": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'filters.ProductsFiltersMenuSelected' */ './filters/widgets/ProductsFiltersMenuSelected.js'))
  },
  "banners.CmsBannersItem": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'banners.CmsBannersItem' */ './banners/views/cmsBanners/CmsBannersItem.js'))
  },
  "banners.Banner": {
    "preload": true,
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'banners.Banner' */ './banners/widgets/Banner.js'))
  },
  "banners.CmsDesignBlock": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'banners.CmsDesignBlock' */ './banners/widgets/CmsDesignBlock.js'))
  },
  "banners.CmsDesignBlockAddBanner": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'banners.CmsDesignBlockAddBanner' */ './banners/widgets/CmsDesignBlockAddBanner.js'))
  },
  "banners.DesignBlock": {
    "preload": true,
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'banners.DesignBlock' */ './banners/widgets/DesignBlock.js'))
  },
  "banners.PageBanners": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'banners.PageBanners' */ './banners/widgets/PageBanners.js'))
  },
  "design.CmsDesignBlockCards": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'design.CmsDesignBlockCards' */ './design/widgets/CmsDesignBlockCards.js'))
  },
  "design.CmsDesignBlockImageText": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'design.CmsDesignBlockImageText' */ './design/widgets/CmsDesignBlockImageText.js'))
  },
  "design.CmsDesignBlocks": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'design.CmsDesignBlocks' */ './design/widgets/CmsDesignBlocks.js'))
  },
  "design.DesignBlockCards": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'design.DesignBlockCards' */ './design/widgets/DesignBlockCards.js'))
  },
  "design.DesignBlockImageText": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'design.DesignBlockImageText' */ './design/widgets/DesignBlockImageText.js'))
  },
  "design.DesignBlocksLoadByCode": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'design.DesignBlocksLoadByCode' */ './design/widgets/DesignBlocksLoadByCode.js'))
  },
  "design.DesignBlocksRender": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'design.DesignBlocksRender' */ './design/widgets/DesignBlocksRender.js'))
  },
  "seo.ProductsSeoBrandChange": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'seo.ProductsSeoBrandChange' */ './seo/widgets/ProductsSeoBrandChange.js'))
  },
  "seo.ProductsSeoCategoryChange": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'seo.ProductsSeoCategoryChange' */ './seo/widgets/ProductsSeoCategoryChange.js'))
  },
  "seo.ProductsSeoProductChange": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'seo.ProductsSeoProductChange' */ './seo/widgets/ProductsSeoProductChange.js'))
  },
  "seo.SeoBlogChange": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'seo.SeoBlogChange' */ './seo/widgets/SeoBlogChange.js'))
  },
  "products.CmsProductsGroupsItemFilters": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'products.CmsProductsGroupsItemFilters' */ './products/views/cmsProductsGroups/CmsProductsGroupsItemFilters.js'))
  },
  "products.CmsDesignBlock": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'products.CmsDesignBlock' */ './products/widgets/CmsDesignBlock.js'))
  },
  "products.CmsProductDrawer": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'products.CmsProductDrawer' */ './products/widgets/CmsProductDrawer.js'))
  },
  "products.CmsProductsDrawer": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'products.CmsProductsDrawer' */ './products/widgets/CmsProductsDrawer.js'))
  },
  "products.DesignBlock": {
    "preload": true,
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'products.DesignBlock' */ './products/widgets/DesignBlock.js'))
  },
  "products.ProductRender": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'products.ProductRender' */ './products/widgets/ProductRender.js'))
  },
  "texteditor.TextEditor": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'texteditor.TextEditor' */ './texteditor/editorSimple/TextEditor.js'))
  },
  "texteditor.CmsDesignBlock": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'texteditor.CmsDesignBlock' */ './texteditor/widgets/CmsDesignBlock.js'))
  },
  "texteditor.DesignBlock": {
    "preload": true,
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'texteditor.DesignBlock' */ './texteditor/widgets/DesignBlock.js'))
  },
  "wishlist.WishlistButton": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'wishlist.WishlistButton' */ './wishlist/widgets/WishlistButton.js'))
  },
  "wishlist.WishlistProductButton": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'wishlist.WishlistProductButton' */ './wishlist/widgets/WishlistProductButton.js'))
  },
  "brands.BrandRender": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'brands.BrandRender' */ './brands/widgets/BrandRender.js'))
  },
  "brands.CmsBrandsDrawer": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'brands.CmsBrandsDrawer' */ './brands/widgets/CmsBrandsDrawer.js'))
  },
  "brands.CmsBrandsFilter": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'brands.CmsBrandsFilter' */ './brands/widgets/CmsBrandsFilter.js'))
  },
  "brands.CmsDesignBlock": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'brands.CmsDesignBlock' */ './brands/widgets/CmsDesignBlock.js'))
  },
  "brands.DesignBlock": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'brands.DesignBlock' */ './brands/widgets/DesignBlock.js'))
  },
  "brands.ProductsBrandsMenu": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'brands.ProductsBrandsMenu' */ './brands/widgets/ProductsBrandsMenu.js'))
  },
  "brands.ProductsBrandsMenuSelected": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'brands.ProductsBrandsMenuSelected' */ './brands/widgets/ProductsBrandsMenuSelected.js'))
  },
  "orders.BasketButton": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'orders.BasketButton' */ './orders/widgets/BasketButton.js'))
  },
  "orders.CmsOrderDrawer": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'orders.CmsOrderDrawer' */ './orders/widgets/CmsOrderDrawer.js'))
  },
  "orders.CmsUnseenOrdersCount": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'orders.CmsUnseenOrdersCount' */ './orders/widgets/CmsUnseenOrdersCount.js'))
  },
  "orders.ProductForm": {
    "lazy": ReactLazyWithPreload(() => import(/* webpackChunkName: 'orders.ProductForm' */ './orders/widgets/ProductForm.js'))
  }
}
